class AnniversaryUserStories extends HTMLElement {
  connectedCallback() {
    if (this.abortController) return
    this.abortController = new AbortController()
    const { signal } = this.abortController
    this.viewport = this.querySelector('[data-story-viewport]')
    this.cards = [...this.querySelectorAll('[data-anniversary-story]')]
    this.previous = this.querySelector('[data-story-previous]')
    this.next = this.querySelector('[data-story-next]')
    this.previous?.addEventListener('click', () => this.move(-1), { signal })
    this.next?.addEventListener('click', () => this.move(1), { signal })
    this.viewport?.addEventListener('scroll', () => this.updateControls(), {
      signal,
      passive: true,
    })
    this.addEventListener(
      'shopify:block:select',
      (event) => {
        if (matchMedia('(max-width: 749px)').matches) return
        const index = this.cards.findIndex((card) => card.dataset.blockId === event.detail?.blockId)
        if (index !== -1) this.scrollTo(index * this.pitch(), false)
      },
      { signal },
    )
    document.addEventListener(
      'shopify:section:unload',
      (event) => {
        if (event.target === this || event.target.contains?.(this)) this.disconnectedCallback()
      },
      { signal },
    )
    this.resizeObserver = new ResizeObserver(() =>
      this.scrollTo(this.viewport?.scrollLeft ?? 0, false),
    )
    if (this.viewport) this.resizeObserver.observe(this.viewport)
    this.scrollTo(this.viewport?.scrollLeft ?? 0, false)
    this.setAttribute('data-enhanced', '')
  }

  pitch() {
    return this.cards.length > 1 ? this.cards[1].offsetLeft - this.cards[0].offsetLeft : 0
  }

  maximum() {
    return !this.viewport || matchMedia('(max-width: 749px)').matches
      ? 0
      : Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth)
  }

  move(direction) {
    if (!this.viewport || !this.pitch()) return
    const current = this.viewport.scrollLeft || 0
    const pitch = this.pitch()
    const index =
      direction > 0
        ? Math.floor(current / pitch + 0.001) + 1
        : Math.ceil(current / pitch - 0.001) - 1
    this.scrollTo(index * pitch)
  }

  scrollTo(target, animate = true) {
    if (!this.viewport) return
    const left = Math.max(0, Math.min(this.maximum(), target))
    this.viewport.scrollTo({
      left,
      behavior:
        animate && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto',
    })
    this.updateControls(left)
  }

  updateControls(position = this.viewport?.scrollLeft ?? 0) {
    if (this.previous) this.previous.disabled = position <= 1
    if (this.next) this.next.disabled = position >= this.maximum() - 1
  }

  disconnectedCallback() {
    this.abortController?.abort()
    this.abortController = null
    this.resizeObserver?.disconnect()
    this.resizeObserver = null
    this.removeAttribute('data-enhanced')
  }
}

if (!customElements.get('anniversary-user-stories')) {
  customElements.define('anniversary-user-stories', AnniversaryUserStories)
}
